// extracted by mini-css-extract-plugin
export default {"stopButton":"Components_m_styles__stopButton__cM6hA"};